import * as React from "react";

import SvgAssetsEmptyState from "@svg/empty-assets";

import { Empty } from "@replo/design-system/components/empty/Empty";

export const AssetGridEmpty: React.FC<{
  title: string;
  description?: string;
}> = ({ title, description }) => {
  return (
    <div className="flex w-full flex-1 flex-col">
      <div className="bg-sheet border-0.5 border-border flex h-full flex-col items-center justify-center rounded-sm border-dashed p-5">
        <Empty
          media={<SvgAssetsEmptyState />}
          title={title}
          description={description}
          size="sm"
        />
      </div>
    </div>
  );
};
